@if (stitchItem) {
  <div class="modal-content">
    <ng-container split-left-pane>
      @switch (stitchType) {
        @case ('message-folder') {
          <app-message-folder-form *appMailAppContext
            class="modal-form"
            split-left-pane
            [folder]="asMessageFolder"
            (close)="close()"
            />
        }
        @case ('message') {
          <app-message2-form *appMailAppContext
            class="modal-form"
            [message]="asMessage"
            [autoSaveAllowed]="false"
            (close)="close()"
            />
        }
        @case ('calendar') {
          <app-calendar-form *appCalendarAppContext
            class="modal-form"
            [calendar]="asCalendar"
            (close)="close()"
            />
        }
        @case ('event') {
          <app-event-form *appCalendarAppContext
            class="modal-form"
            [event]="asCalendarEvent"
            (close)="close()"
            />
        }
        @case ('project') {
          <app-project-form *appTaskingAppContext
            class="modal-form"
            [project]="asProject"
            (close)="close()"
            />
        }
        @case ('task') {
          <app-task-form *appTaskingAppContext
            class="modal-form"
            [task]="asTask"
            (close)="close()"
            />
        }
        @case ('notebook') {
          <app-notebook-form *appNotesAppContext
            class="modal-form"
            [notebook]="asNotebook"
            (close)="close()"
            />
        }
        @case ('note') {
          <app-note-form *appNotesAppContext
            class="modal-form"
            [note]="asNote"
            (close)="close()"
            />
        }
        @case ('group') {
          <app-group-form *appContactsAppContext
            class="modal-form"
            [group]="asGroup"
            (close)="close()"
            />
        }
        @case ('contact') {
          <app-contact-form *appContactsAppContext
            class="modal-form"
            [contact]="asContact"
            (close)="close()"
            />
        }
        @case ('folder') {
          <app-folder-form *appFilesAppContext
            class="modal-form"
            [folder]="asFolder"
            (close)="close()"
            />
        }
        @case ('file') {
          <app-file-form *appFilesAppContext
            class="modal-form"
            [file]="asFile"
            (close)="close()"
            />
        }
        @case ('sheet-folder') {
          <app-sheet-folder-form *appSheetsAppContext
            class="modal-form"
            [sheetFolder]="asSheetFolder"
            (close)="close()"
            />
        }
        @case ('sheet') {
          <app-sheet-form *appSheetsAppContext
            class="modal-form"
            [sheet]="asSheet"
            (close)="close()"
            />
        }
      }
    </ng-container>
  </div>
}
